import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { SystemService } from '../services/system.service';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userName = 'User';
  userRole = '';
  userInitials = 'U';
  username = '';

  constructor(
    private authService: AuthService,
    public systemService: SystemService,
    private languageService: LanguageService
  ) { }

  get userRoleLabel(): string {
    return this.languageService.roleLabel(this.userRole);
  }

  toggleLanguage(): void {
    this.languageService.toggle();
  }

  async ngOnInit(): Promise<void> {
    try {
      await this.authService.getProfile();
    } catch {
      // Fall back to stored session user.
    }
    this.loadUserProfile();
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }

  private loadUserProfile(): void {
    const user = this.authService.getUser();
    const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim();
    this.userName = fullName || user?.name || user?.username || 'User';
    this.username = user?.username || '';

    const role = user?.role?.name || user?.role;
    this.userRole = role ? String(role) : '';

    this.userInitials = this.userName
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part: string) => part[0].toUpperCase())
      .join('') || 'U';
  }
}
